// extracted by mini-css-extract-plugin
export default {"animatedRoute":"AnimatedRoute_animatedRoute__QrSWH animatedRouteContainer"};